import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

import { TSegmentLogo } from '../types';

import { segmentsQueryKeys } from './query-keys';

export async function deleteSegmentLogo(params: batchLogoParams): Promise<TSegmentLogo[]> {
  const { id } = params;
  return mediaManagerClient.delete(`/api/v1/segment_logos/${id}`).then(({ data }) => data);
}

type MutationFn = typeof deleteSegmentLogo;

type TUseDeleteSegmentLogoParams = {
  config?: MutationConfig<MutationFn>;
};

export type batchLogoParams = {
  id: string;
  silently?: boolean;
};

export function useDeleteSegmentLogo({ config }: TUseDeleteSegmentLogoParams) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: ({ id, silently = false }: batchLogoParams) => deleteSegmentLogo({ id, silently }),
    onError(error) {
      addErrorNotification(t('No se ha podido eliminar el logo del segmento'));
      console.error(error);
    },
    onSuccess(_data, variables: batchLogoParams) {
      if (!variables.silently) {
        addSuccessNotification(t('Logo(s) del segmento eliminado(s) correctamente'));
      }
      queryClient.invalidateQueries({ queryKey: segmentsQueryKeys.segmentLogo });
    },
  });
}
